/** Maps a Transloco language code to the locale used for date formatting. English gets DD/MM/YYYY via en-GB. */
export function localeForLang(lang: string): string {
  return lang === "en" ? "en-GB" : lang;
}
